import { render, staticRenderFns } from "./ModalTransferSubmit.vue?vue&type=template&id=c2b943b2&"
import script from "./ModalTransferSubmit.vue?vue&type=script&lang=js&"
export * from "./ModalTransferSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports